import React from 'react';
import styles from './TableBox.module.scss';
import PropTypes from 'prop-types';
import { Table, Typography } from 'antd';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip } from '@/components/TableCell';
import { regFenToYuan } from '@/util/money';
import { FloatConversion } from '@/util/conversion';
import { Tooltip } from 'antd';
import moment from 'moment';

const { Text } = Typography;
const floatConversion = new FloatConversion();

const TableBox = ({
    shippingFees: {
        dataList = [],
        pageNum,
        pageSize,
        resultTotal
    },
    onPageChange,
    onTableOperate,
}) => {

    const renderCompanyTemplateName = (text)=>{
        return (<Tooltip placement="topLeft" title={text}>{text}</Tooltip>);
    };

    const renderTooltip = (text)=>{
        return (<Tooltip overlayStyle={{maxWidth: '400px'}} placement="topLeft" title={text}>{text ? text : '--'}</Tooltip>);
    };

    const renderControlTime = (id, item)=>{
        return <span>{moment(item.gmtStart).format('YYYY-MM-DD HH:mm')} 至 {moment(item.gmtEnd).format('YYYY-MM-DD HH:mm')}</span>;
    };

    const onControlLogOperateCell = (text, item)=>{
        let status = item.statusCode;
        
        return <div className={styles.action}>
            {status == 'NOTSTART' ? (
                <>
                    <div className={styles.item} onClick={() => onTableOperate(text, 'cancel', item)} >设置无效</div>
                    <div className={styles.item} onClick={() => onTableOperate(text, 'edit', item)} >编辑</div>
                </>
            ) : null}
            { status == 'ING' ? (<div className={styles.item} onClick={() => onTableOperate(text, 'over', item)} >终止</div>) : null}
        </div>;
    };

    const renderControlVal = (val, item)=>{
        let type = item.type;
        let str = '';
        switch (type){
            case '百分比例':
            str = (val / 100)+'%';
            break;
        case '固定金额':
            str = '￥' + regFenToYuan(val);
            break;
        }
        return <span>{str}</span>;
    };

    const controlLogColumns = [
        {
            title: '运费调控ID',
            dataIndex: 'id',
            width: '130px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '运费模板名称',
            dataIndex: 'templateName',
            width: '120px',
            align: 'left',
            onCell: tooltipStyle,
            render: renderCompanyTemplateName
        },
        {
            title: '调控模板类型',
            dataIndex: 'templateTypeName',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '调控原因',
            dataIndex: 'reason',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '调控地域',
            dataIndex: 'cityList',
            width: '400px',
            align: 'center',
            onCell: tooltipStyle,
            render: renderTooltip
        },
        {
            title: '调控时段',
            dataIndex: 'gmtStart',
            width: '250px',
            align: 'center',
            onCell: tooltipStyle,
            render: renderControlTime
        },
        {
            title: '调控方式',
            dataIndex: 'type',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '调控值',
            dataIndex: 'amount',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: renderControlVal
        },
        {
            title: '状态',
            dataIndex: 'statusName',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '创建时间',
            dataIndex: 'gmtCreate',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作人',
            dataIndex: 'modifyUserName',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作时间',
            dataIndex: 'gmtModify',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            width: '150px',
            align: 'center',
            fixed: 'right',
            onCell: tooltipStyle,
            render: onControlLogOperateCell
        }
    ];

    return <div className={styles.tableContainer}>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={record => record.id}
            columns={controlLogColumns}
            dataSource={dataList}
            pagination={false}
            scroll={{x: 1200, y: true }}
        />
        <XPagination
            resultTotal={resultTotal}
            pageSize={pageSize}
            pageNum={pageNum}
            onChange={onPageChange}
        />
    </div>;
};

TableBox.propTypes = {
    onPageChange: PropTypes.func,//分页变化
    shippingFees: PropTypes.object,//表格数据
    onTableOperate: PropTypes.func,//表格操作
    curTabID: PropTypes.string,
};

export default TableBox;